import { entity } from "@mhmo91/ican";
import { firestore } from "@mhmo91/ican/firestore/binding";
import type { Timestamp } from "firebase/firestore";
import { z } from "zod";
import { type Actor, Id } from "../workspace.entity.ts";

// A project-wide fenced lease serializes shared allowlist reconciliation; this
// document contains no per-domain state or provider configuration copy.
export const DomainPolicySchema = z
	.object({
		runId: Id,
		expiresAt: z.custom<Timestamp>(),
		fence: z.number().int().nonnegative(),
	})
	.strict();
export type DomainPolicy = z.infer<typeof DomainPolicySchema>;
export const DomainPolicy = entity<Actor>()({
	schema: DomainPolicySchema,
	actions: [] as const,
})
	.pipe(() => [])
	.adaptor(
		firestore({ hierarchicalGrants: true, path: "system/domainPolicy" }),
	);
